import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class CouponService extends BaseService {

  private env = environment;

  constructor(
    http: HttpClient,
    errorHandlerService: ErrorHandlerService,) {
    super(http, errorHandlerService);
  }

  applyCoupon(idPlanPayment: string, couponName: string, memberId: string, operationType: string, dependentsAmount: number) {
    const params = new HttpParams()
      .set('couponName', couponName)
      .set('memberId', memberId)
      .set('operationType', operationType)
      .set('dependentsAmount', dependentsAmount.toString());

    return this.get(`${this.env.publicApiSocioUrl}v1/socio/coupon/apply-coupon/${idPlanPayment}`, { params });
  }

  getMemberCoupons(memberId: string, usageType: string | null = null) {
    let params = new HttpParams();
    if (usageType) {
      params = params.set('usageType', usageType);
    }
    return this.get(`${this.env.socioApiUrl}/member-coupons/member/${memberId}/active-usable`, { params });
  }

}
